import React from 'react';
import './MailercloudLogo.css';

interface MailercloudLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'horizontal' | 'icon';
  className?: string;
  hideSubtext?: boolean;
}

const MailercloudLogo: React.FC<MailercloudLogoProps> = React.memo(({
  size = 'md',
  variant = 'horizontal',
  className = '',
  hideSubtext = false,
}) => {
  const logoSizes = {
    sm: { width: 120, height: 32 },
    md: { width: 160, height: 42 },
    lg: { width: 200, height: 52 },
    xl: { width: 240, height: 62 },
  };

  const iconSizes = {
    sm: { width: 32, height: 32 },
    md: { width: 42, height: 42 },
    lg: { width: 52, height: 52 },
    xl: { width: 62, height: 62 },
  };

  const dimensions = variant === 'icon' ? iconSizes[size] : logoSizes[size];

  if (variant === 'icon') {
    return (
      <div className={`mailercloud-logo-icon ${className}`}>
        <img
          src="https://app2.mailercloud.com/img/brand-icon.4351159a.svg"
          alt="MailerCloud"
          width={dimensions.width}
          height={dimensions.height}
          style={{
            display: 'block',
            maxWidth: '100%',
            height: 'auto'
          }}
        />
      </div>
    );
  }

  return (
    <div className={`mailercloud-logo ${className}`} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      {/* Icon part - External SVG */}
      <img
        src="https://app2.mailercloud.com/img/brand-icon.4351159a.svg"
        alt="MailerCloud"
        width="42"
        height="42"
        style={{
          display: 'block',
          maxWidth: '100%',
          height: 'auto'
        }}
      />
      
      {/* Text part - External SVG */}
      <div className="mailercloud-text">
        <img
          src="https://app2.mailercloud.com/img/text-logo.db22e275.svg"
          alt="Mailercloud"
          style={{
            display: 'block',
            height: 'auto',
            maxWidth: '100%'
          }}
        />
        {!hideSubtext && (
          <div
            style={{
              fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
              fontSize: '10px',
              fontWeight: '500',
              color: '#6b7280',
              letterSpacing: '0.5px',
              textTransform: 'uppercase',
              marginTop: '2px'
            }}
          >
            Customer Onboarding
          </div>
        )}
      </div>
    </div>
  );
});

MailercloudLogo.displayName = 'MailercloudLogo';

export default MailercloudLogo;